module.exports = __webpack_public_path__ + "assets/dd642e79bae61bf66689de7b2cec440a.mp3";